import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace WorkingTable {
    /**
    *  获取今日数量统计
    */
    export var Today = (): Promise<any> => {
        return Get(`/msls/WorkingTable/Today`, {});
    };
    /**
     * 代办处理统计
     */
    export var Todo = (): Promise<any> => {
        return Get(`/msls/WorkingTable/Todo`, {});
    };

    /**
   * 异常管理列表
   */
    export var AnomalyList = (query: any): Promise<any> => {
        return Get(`/msls/WorkingTable/AnomalyList?${qs.stringify(query)}`, {});
    };

    /**
     * 获取通知公告
     */
    export var GetNotices = (query: any): Promise<any> => {
        return Get(`/msls/WorkingTable/GetNotices?${qs.stringify(query)}`, {});
    };

    /**
   * 获取消息通知
   */
    export var GetSystemMsgs = (query: any): Promise<any> => {
        return Get(`/msls/WorkingTable/GetSystemMsgs?${qs.stringify(query)}`, {});
    };

    /**
  * 获取未读消息数量
  */
    export var GetNoReadCount = (query: any): Promise<any> => {
        return Get(`/msls/WorkingTable/GetNoReadCount?${qs.stringify(query)}`, {});
    };

    /**
  * 清空通知/消息  1通知 2消息
  */
    export var Clear = (query: any): Promise<any> => {
        return Post(`/msls/WorkingTable/Clear?${qs.stringify(query)}`, {});
    };

    export var GetOrderIdsByCarrierOrderId = (query: any): Promise<any> => {
        return Get(`/msls/WorkingTable/GetOrderIdsByCarrierOrderId?${qs.stringify(query)}`, {});
    };



    /**
   * 阅读通知公告
   */
    export var Read = (id: any): Promise<any> => {
        return Post(`/msls/WorkingTable/Read/${id}`, {});
    };

    /**
  * 详情
  */
    export var Notice = (id: any): Promise<any> => {
        return Get(`/msls/WorkingTable/Notice/${id}`, {});
    };

    /**
  * 阅读系统消息
  */
    export var ReadSystemMsg = (id: any): Promise<any> => {
        return Post(`/msls/WorkingTable/ReadSystemMsg/${id}`, {});
    };



    export var PreConnect = (): Promise<any> => {
        return Get(`/msls/ws/PreConnect`, {});
    };

    export var DataAnalysis = (query: any): Promise<any> => {
        return Get(`/msls/CarrierOrder/DataAnalysis?${qs.stringify(query)}`, {});
    };

    export var DataAnalysisExport = (query: any): Promise<any> => {
        return Download(`/msls/CarrierOrder/DataAnalysisExport?${qs.stringify(query)}`, {});
    };
    /**
     * 获取客户/基地名称
     */
    export var GetDropDownList = (query): Promise<any> => {
        return Get(`/msls/CustomerBase/GetDropDownList?${qs.stringify(query)}`, {});
    }
    /**
     * 获取车队
     */
    export var GetCarrierList = (data): Promise<any> => {
        return Get(`/msls/Carrier/GetCarrierList?${qs.stringify(data)}`, {});
    }
    /**
     * 获取汇总统计
     */
    export var GetSummarize = (query: any): Promise<any> => {
        return Get(`/msls/DataAnalysis/GetSummarize?${qs.stringify(query)}`, {});
    }
    /**
     * 获取日报表
     */
    export var GetDayReport = (query: any): Promise<any> => {
        return Get(`/msls/DataAnalysis/GetDayReport?${qs.stringify(query)}`, {});
    }
    /**
     * 获取超48小时发货
     */
    export var GetDataThan = (query: any): Promise<any> => {
        return Get(`/msls/DataAnalysis/Get?${qs.stringify(query)}`, {});
    }
    export var GetSendLogList = (query: any): Promise<any> => {
        return Get(`/msls/InterfaceLog/GetSendLogList?${qs.stringify(query)}`, {});
    }
    export var GetReceiveLogList = (query: any): Promise<any> => {
        return Get(`/msls/InterfaceLog/GetReceiveLogList?${qs.stringify(query)}`, {});
    }
    /**数据汇总导出 */
    export var SumAnalysisExport = (query: any): Promise<any> => {
        return Download(`/msls/DataAnalysis/GetSummarizeExport?${qs.stringify(query)}`, {});
    };
    /**日报表导出 */
    export var DayAnalysisExport = (query: any): Promise<any> => {
        return Download(`/msls/DataAnalysis/GetDayReportExport?${qs.stringify(query)}`, {});
    };
    /**获取超48小时发货导出 */
    export var GetExport = (query: any): Promise<any> => {
        return Download(`/msls/DataAnalysis/GetExport?${qs.stringify(query)}`, {});
    };
    /**
     * 获取开单派车统计
     */
    export var GetDispatchReport = (query: any): Promise<any> => {
        return Get(`/msls/DataAnalysis/GetDispatchReport?${qs.stringify(query)}`, {});
    }
    /**开单派车导出 */
    export var GetDispatchReportExport = (query: any): Promise<any> => {
        return Download(`/msls/DataAnalysis/GetDispatchReportExport?${qs.stringify(query)}`, {});
    };
    /**
   * 开单派车统计
   */
    export var GetDispatchTotalReport = (query: any): Promise<any> => {
        return Get(`/msls/DataAnalysis/GetDispatchTotalReport?${qs.stringify(query)}`, {});
    };
    /**
 * 获取汇总统计
 */
    export var GetAuditSummary = (query: any): Promise<any> => {
        return Get(`/msls/DataAnalysis/GetAuditSummary?${qs.stringify(query)}`, {});
    };
    /**
     * 获取日报表
     */
    export var GetAuditSummaryExport = (query: any): Promise<any> => {
        return Download(`/msls/DataAnalysis/GetAuditSummaryExport?${qs.stringify(query)}`, {});
    };
}
